import { Drawer, Tabs } from 'antd';
import { useContext, useState } from 'react';
import { AutomateReviewsTab } from './AutomateReviewsTab';
import { CompanyIAGuide } from '../../../../../components/model/ia/CompanyIAGuide';
import { SettingOutlined } from '@ant-design/icons';
import { DrawerContext } from '../../../../../../store/DrawerContext/DrawerContext';
import { TestReplyWithAIDrawer } from './TestReplyWithAIDrawer';
import { DrawerPanelTitle, drawerPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';

export const ConfigureIADrawer = () => {

	const { setConfigureIADrawer } = useContext(DrawerContext);
	const [openDrawer, setOpenDrawer] = useState(false);

	return (
		<Drawer
			placement="right"
			width={'40%'}
			title={
				<DrawerPanelTitle
					title={<><SettingOutlined /> Respuestas con IA</>}
					isProject={false}
				/>
			}
			onClose={() => setConfigureIADrawer(false)}
			open={true}
			{...drawerPanelStyles}
		>
			<Tabs defaultActiveKey="1" type="line" style={{ width: '100%' }}>
				<Tabs.TabPane tab={<span className='title-tabPane'>Personalizar</span>} key="1">
					<CompanyIAGuide onTestClick={() => setOpenDrawer(true)} />
				</Tabs.TabPane>

				<Tabs.TabPane tab={<span className='title-tabPane'>Automatizar</span>} key="2">
					<AutomateReviewsTab openDrawer={false} setOpenDrawer={undefined} />
				</Tabs.TabPane>
			</Tabs>

			{openDrawer && <TestReplyWithAIDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />}
		</Drawer>
	);
};
